import { useEffect, useState } from "react";

const useSessionStorage = (key, initialValue) => {
    const [value, setValue] = useState(() => {
        const item = sessionStorage.getItem(key);
        return item ? JSON.parse(item) : initialValue;
    });

    useEffect(() => {
        sessionStorage.setItem(key, JSON.stringify(value));
    }, [value, key]);

    return [value, setValue];
};

export default useSessionStorage;